export default __webpack_public_path__ + "static/media/logoPlayContrataMais2.8dadb563.png";